export function AboutTab() {
  return (
    <div className="max-w-xl space-y-3 text-sm text-text-soft">
      <h2 className="text-xl font-medium text-text">About</h2>
      <p>vaultwisp — a secure, offline-first personal vault for files.</p>
      <p>Post-quantum crypto primitives from saorsa-pqc. Zero-trust storage backends.</p>
      <p>
        Source:{" "}
        <a
          href="https://github.com/loureirorg/vaultwisp"
          className="text-accent-soft hover:underline"
        >
          github.com/loureirorg/vaultwisp
        </a>
      </p>
    </div>
  );
}
